import { i18n } from '@apps/main/modules/localization/localizationSetup';

import { BoardBasisCode } from '@libs/trip-planner-interfaces';
import { exhaustiveGuard } from '@libs/utils';

const { t } = i18n.global;

export function getBoardBasisText(boardBasis: BoardBasisCode): string {
  switch (boardBasis) {
    case BoardBasisCode.RoomOnly:
      return t('filter.boardBasis.no_meals');
    case BoardBasisCode.Breakfast:
      return t('filter.boardBasis.included_breakfast');
    case BoardBasisCode.HalfBoard:
      return t('filter.boardBasis.included_half_board');
    case BoardBasisCode['HalfBoardPlus']:
      return t('filter.boardBasis.included_half_board_plus');
    case BoardBasisCode.FullBoard:
      return t('filter.boardBasis.included_full_board');
    case BoardBasisCode.AlInclusive:
      return t('filter.boardBasis.all_inclusive');
    default:
      exhaustiveGuard(boardBasis, 'the board basis code is not defined');
  }
}

export function getBoardBasisTextNoIncluded(
  boardBasis: BoardBasisCode
): string {
  switch (boardBasis) {
    case BoardBasisCode.RoomOnly:
      return t('filter.boardBasis.no_meals');
    case BoardBasisCode.Breakfast:
      return t('filter.boardBasis.breakfast');
    case BoardBasisCode.HalfBoard:
      return t('filter.boardBasis.half_board');
    case BoardBasisCode['HalfBoardPlus']:
      return t('filter.boardBasis.half_board_plus');
    case BoardBasisCode.FullBoard:
      return t('filter.boardBasis.full_board');
    case BoardBasisCode.AlInclusive:
      return t('filter.boardBasis.all_inclusive');
    default:
      exhaustiveGuard(boardBasis, 'the board basis code is not defined');
  }
}
